import { client } from '@app/util'

import requestLogin from '../request/login'
import setAuth from '../action/set-auth'

import isLoading from './is-loading'
import addError from './add-error'
import firstLoad from './first-load'

export default (params) => {
  return async (dispatch) => {
    // `params.silent` keeps 'first-load' and 'me' out of the loading state, and Routes.js
    // swaps the WHOLE page tree for its loader whenever either of them is in it. A screen
    // that takes the session mid-flow and has to stay where it is passes it — /accept-invite
    // does, so that creating the account does not tear the card down on its way to the
    // code step. Everything else keeps the loader.
    const doLogin = async (token) => {
      await dispatch(setAuth(token))
      await client.resetStore()
      await dispatch(firstLoad(false, params.silent))
    }
    if (!params.silent) dispatch(isLoading('log-in'))
    if (params.auth) {
      await doLogin(params.auth)
      if (!params.silent) dispatch(isLoading('log-in', true))
    } else {
      const result = await requestLogin(params)
      if (result.error) {
        dispatch(addError(result.error))
      } else {
        if (result.mfaEnabled && !result.token) {
          dispatch(isLoading('log-in', true))
          return { mfa: true, availableMethods: result.mfaMethods }
        }
        await doLogin(result.token)
      }
      dispatch(isLoading('log-in', true))
      return result
    }
  }
}
